import { render, staticRenderFns } from "./showPublicNote.vue?vue&type=template&id=589b1946&"
import script from "./showPublicNote.vue?vue&type=script&lang=js&"
export * from "./showPublicNote.vue?vue&type=script&lang=js&"
import style0 from "./showPublicNote.vue?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports